module.exports = "/_next/static/images/production-1-min-b5095e0ae396216958a1db1cd7b49d28.jpg";